import { useState } from "react";

import { useQuery } from "@apollo/client";

import { FETCH_RATINGS_SUMMARY_LAST_60_DAYS } from "../app/graphql/queries";
import { RatingsInterface, SearchHit } from "../app/search/search.types";

const useRatingsForRecipes = (recipes: SearchHit[]) => {
  const [ratingsHashMap, setRatingsHashMap] = useState<Record<string, { rating: number | null, ratingCount: number | null }>>({});

  const { loading, error } = useQuery(FETCH_RATINGS_SUMMARY_LAST_60_DAYS, {
    onCompleted: (data) => {
      const newRatingsHashMap: Record<string, { rating: number | null, ratingCount: number | null }> = {};
      data.ratingsSummaryLast60DaysView.forEach((rating: RatingsInterface) => {
        newRatingsHashMap[rating.recipeID] = {
          rating: rating.rating || null,
          ratingCount: rating.ratingCount || null,
        };
      });
      setRatingsHashMap(newRatingsHashMap);
    },
    onError: (err) => {
      console.error("Error fetching ratings:", err);
    }
  });

  const recipesWithRatings = recipes.map((recipe: SearchHit) => {
    const { rating = null, ratingCount = null } = ratingsHashMap[recipe.id] || {};
    return {
      ...recipe,
      rating,
      ratingCount
    };
  });

  return { recipesWithRatings, loading, error };
};

export default useRatingsForRecipes;
